<template>
  <div class="page">
    <transition name="fade">
      <div class="loader" v-show="show">
        <bounce-loader :loading="show" :color="'#0d8987'" :size="size" :radius="radius"></bounce-loader>

      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>

  import EventBus from '../../event-bus.js';
  import BounceLoader from 'vue-spinner/src/BounceLoader.vue'



  export default {
    name: "Loader",
    data() {
      return {
        show: true,
          size: '30vmin',
          margin: '2px',
          radius: '100%'

      }
    },
      components:{
          BounceLoader
      },
    mounted() {
      EventBus.$on('end-loading', data => {
        setTimeout(() => {
          this.show = false;
        }, 800);


      });
      EventBus.$on('start-loading', data => {
        this.show = true;

      });
    }
  }
</script>

<style scoped>
  .page {
    min-height: 100vh;
    position: relative;
    background: #0a121f;
    overflow: auto;
  }

  .loader {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10000;
    position: fixed;
    background: #0a121f;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>